import React from 'react'
import styles from './Footer.module.css'
import { LocalizedLink } from '~/components/LocalizedLink/LocalizedLink'
import { FormattedMessage } from 'react-intl'

export const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <nav className={styles.menu}>
          <ul>
            <li>
              <LocalizedLink href="/products">
                <FormattedMessage id="homepage.footer.products" />
              </LocalizedLink>
            </li>
            <li>
              <LocalizedLink href="/configurator/stand">
                <FormattedMessage id="homepage.footer.stands" />
              </LocalizedLink>
            </li>
            <li>
              <LocalizedLink href="/configurator/tv-stand">
                <FormattedMessage id="homepage.footer.tvstands" />
              </LocalizedLink>
            </li>
            <li>
              <LocalizedLink href="/configurator/bedside">
                <FormattedMessage id="homepage.footer.bedsides" />
              </LocalizedLink>
            </li>
          </ul>
        </nav>
        <nav className={styles.menu}>
          <ul>
            <li>
              <LocalizedLink href="/about-us">
                <FormattedMessage id="homepage.menu.aboutUsTitle" />
              </LocalizedLink>
            </li>
            <li>
              <LocalizedLink href="/blog">
                <FormattedMessage id="homepage.menu.blogTitle" />
              </LocalizedLink>
            </li>
            <li>
              <LocalizedLink href="/faq">
                <FormattedMessage id="homepage.menu.faqTitle" />
              </LocalizedLink>
            </li>
            <li>
              <LocalizedLink href="/contacts">
                <FormattedMessage id="homepage.menu.contactsTitle" />
              </LocalizedLink>
            </li>
            <li>
              <LocalizedLink href="/terms">
                <FormattedMessage id="homepage.footer.termsAndConditions" />
              </LocalizedLink>
            </li>
          </ul>
        </nav>
        <div className={styles.logoSection}>
          <LocalizedLink href="/">
            <img alt="logo" src="/logo-white.svg" width={200} />
          </LocalizedLink>
          <p>
            <FormattedMessage id="homepage.footer.followUs" />
          </p>
          <div className={styles.socialIcons}>
            <a
              href="https://www.instagram.com/dulap.studio"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/cdn/soclial/instagram.png" alt="Instagram" />
            </a>
            <a
              href="https://www.facebook.com/share/15j84TravW/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/cdn/soclial/facebook.png" alt="Facebook" />
            </a>
          </div>
          {/* <p className={styles.location}>Chișinău, Republica Moldova</p> */}
        </div>
      </div>
    </footer>
  )
}
